import { useState } from 'react';
import {
  Accordion, AccordionSummary, AccordionDetails, Typography, TextField, InputAdornment,
  IconButton, Tooltip, Box,
} from '@mui/material';
import { ExpandMore, ContentCopy, Check } from '@mui/icons-material';

export default function NetworkPostbackUrl({ url }: { url: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch { /* best-effort; the field stays selectable */ }
  };

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="subtitle1" fontWeight={600}>Postback URL</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Give this to the network for server-to-server conversions. Replace <code>{'{click_id}'}</code> and{' '}
          <code>{'{payout}'}</code> with their macros; <code>nid</code> tags every postback with this network,
          so a misfire is traceable even when the click id is missing.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TextField
            fullWidth size="small" value={url || ''}
            InputProps={{
              readOnly: true,
              sx: { fontFamily: 'monospace', fontSize: '0.8rem' },
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={copied ? 'Copied' : 'Copy'}>
                    <span>
                      <IconButton size="small" onClick={copy} disabled={!url}>
                        {copied ? <Check fontSize="small" color="success" /> : <ContentCopy fontSize="small" />}
                      </IconButton>
                    </span>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
